const fragment = `
  id
  palette {
    id
    name
  }
`;

export const listModelPalettesQuery = `
  query ListModelPalettes(
    $filter: ModelPaletteFilterInput
  ) {
    items: listModelPalettes(filter: $filter) {
      ${fragment}
    }
  }
`;

export const createModelPaletteQuery = `
  mutation CreateModelPalette(
    $input: CreateModelPaletteInput!
  ) {
    item: createModelPalette(input: $input) {
      ${fragment}
    }
  }
`;

export const updateModelPaletteQuery = `
  mutation UpdateModelPalette(
    $input: UpdateModelPaletteInput!
  ) {
    item: updateModelPalette(input: $input) {
      ${fragment}
    }
  }
`;

export const deleteModelPaletteQuery = `
  mutation DeleteModelPalette(
    $id: Int!
  ) {
    item: deleteModelPalette(id: $id) {
      ${fragment}
    }
  }
`;
